import { render, staticRenderFns } from "./AvailabilityPage.vue?vue&type=template&id=18c40d4e&"
import script from "./AvailabilityPage.vue?vue&type=script&lang=js&"
export * from "./AvailabilityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports